import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTASection({
  overline = "Engage with VPCL Infra",
  title = "Let's discuss your next utility-scale project.",
  body = "From feasibility to commissioning, our development desk is ready to engage on tender, EPC and land-led opportunities.",
  primary = { label: "Discuss Your Project", to: "/contact" },
  secondary = { label: "Download Corporate Profile", to: "/contact" },
}) {
  return (
    <section className="bg-[#0B2341] text-white" data-testid="cta-section">
      <div className="container-corp py-20 md:py-24">
        <div className="grid lg:grid-cols-2 gap-12 items-end">
          <div>
            <div className="overline mb-5">{overline}</div>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold leading-tight max-w-xl">
              {title}
            </h2>
          </div>
          <div>
            <p className="text-white/70 text-lg leading-relaxed mb-8 max-w-lg">{body}</p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to={primary.to}
                className="btn-accent group"
                data-testid="cta-primary"
              >
                {primary.label}
                <ArrowRight size={16} className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Link>
              <Link to={secondary.to} className="btn-ghost-light" data-testid="cta-secondary">
                {secondary.label}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
